import React from 'react';

const EditIntegrationSyncModal = ({ onClose, onSave, integration, errors, setErrors, isSubmitting = false }) => {
    const [formData, setFormData] = React.useState({
        sync_enabled: integration?.sync_enabled || false,
        sync_settings: integration?.sync_schedule || {
            mode: 'single',
            batch_size: 50,
            interval_minutes: 15,
            records_per_interval: 15,
            rate_limit: {
                requests_per_minute: 60
            }
        }
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Call the parent's onSave function
        onSave(formData);
    };

    const updateSyncSettings = (field, value) => {
        setFormData(prev => ({
            ...prev,
            sync_settings: {
                ...prev.sync_settings,
                [field]: value
            }
        }));
    };

    const updateNestedSyncSettings = (section, field, value) => {
        setFormData(prev => ({
            ...prev,
            sync_settings: {
                ...prev.sync_settings,
                [section]: {
                    ...prev.sync_settings[section],
                    [field]: value
                }
            }
        }));
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: '#fff',
                padding: '20px',
                borderRadius: '8px',
                width: '90%',
                maxWidth: '600px',
                maxHeight: '90vh',
                overflow: 'auto'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <h2 style={{ fontSize: '24px', margin: 0 }}>Edit Sync Settings - {integration?.name}</h2>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '5px'
                        }}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
                    {isSubmitting && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 10,
                            borderRadius: '8px'
                        }}>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '24px', marginBottom: '10px' }}>⏳</div>
                                <div>Updating Sync Settings...</div>
                            </div>
                        </div>
                    )}
                    
                    <div style={{ marginTop: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
                        <h3 style={{ marginBottom: '15px', fontSize: '16px' }}>
                            Sync Settings
                            <span style={{ marginLeft: '8px', cursor: 'help', color: '#666', fontSize: '14px' }}>ℹ</span>
                        </h3>
                        
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    checked={formData.sync_enabled}
                                    onChange={(e) => setFormData(prev => ({ ...prev, sync_enabled: e.target.checked }))}
                                />
                                <span style={{ fontWeight: 'bold' }}>Enable Scheduled Sync</span>
                            </label>
                        </div>

                        {formData.sync_enabled && (
                            <>
                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                        Sync Mode
                                    </label>
                                    <select
                                        value={formData.sync_settings.mode || 'single'}
                                        onChange={(e) => updateSyncSettings('mode', e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        <option value="single">Single Record</option>
                                        <option value="batch">Batch Processing</option>
                                    </select>
                                </div>

                                {formData.sync_settings.mode === 'batch' && (
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                            Batch Size
                                        </label>
                                        <input
                                            type="number"
                                            value={formData.sync_settings.batch_size || 50}
                                            onChange={(e) => updateSyncSettings('batch_size', parseInt(e.target.value) || 50)}
                                            min="1"
                                            max="1000"
                                            placeholder="50"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    </div>
                                )}

                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                        Interval (minutes)
                                    </label>
                                    <input
                                        type="number"
                                        value={formData.sync_settings.interval_minutes || 15}
                                        onChange={(e) => updateSyncSettings('interval_minutes', parseInt(e.target.value) || 15)}
                                        min="1"
                                        max="1440"
                                        placeholder="15"
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </div>

                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                        Records Per Interval
                                    </label>
                                    <input
                                        type="number"
                                        value={formData.sync_settings.records_per_interval || ''}
                                        onChange={(e) => updateSyncSettings('records_per_interval', e.target.value ? parseInt(e.target.value) : null)}
                                        min="1"
                                        max="10000"
                                        placeholder="Leave empty for no limit"
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </div>

                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                        Rate Limit (requests per minute)
                                    </label>
                                    <input
                                        type="number"
                                        value={formData.sync_settings.rate_limit?.requests_per_minute || 60}
                                        onChange={(e) => updateNestedSyncSettings('rate_limit', 'requests_per_minute', parseInt(e.target.value) || 60)}
                                        min="1"
                                        max="1000"
                                        placeholder="60"
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px',
                        marginTop: '20px'
                    }}>
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={isSubmitting}
                            style={{
                                padding: '10px 20px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                backgroundColor: '#f8f9fa',
                                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                opacity: isSubmitting ? 0.6 : 1
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '4px',
                                backgroundColor: isSubmitting ? '#6c757d' : '#007bff',
                                color: 'white',
                                cursor: isSubmitting ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {isSubmitting ? (
                                <>
                                    <span style={{ marginRight: '8px' }}>⏳</span>
                                    Updating...
                                </>
                            ) : (
                                'Update Sync Settings'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditIntegrationSyncModal; 